import { useCallback, useEffect, useState } from "react";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const ErrorModal = ({
	show,
	error,
}: {
	show: boolean;
	error: Error | null;
}) => {
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWindowWidth(window.innerWidth);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handleGoBack = useCallback(() => {
		globalThis.history.back();
	}, []);

	if (!show) {
		return null;
	}
	return (
		<>
			<div className={"error-modal-overlay"} />
			<TraxModal
				onCancel={handleGoBack}
				onClose={handleGoBack}
				onGoBack={handleGoBack}
				showCancelButton={false}
				showConfirmButton={false}
				showConfirmationButtons={false}
				showGoBackButton={true}
				title={"Error Loading Shipment"}
				type={"confirmation"}
				width={windowWidth < 600 ? "95%" : 600}
			>
				<div>{error?.message}</div>
			</TraxModal>
		</>
	);
};
